import TheGrid from '@/views/campaigns/inpar/bonus/grid'
import Edit from '@/views/campaigns/inpar/bonus/edit'

export default {
  path: '/campaigns/inpar/bonus',
  redirect: '/campaigns/inpar/bonus/index',
  name: 'bonus',
  meta: {
    auth: {
      redirect: {
        name: 'bonus.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bónus'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bonus.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'bonus.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'bonus.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
